export const invoiceStateEnum = [
    {
        stateId: "0000",
        stateName: "开票成功"
    },
    {
        stateId: "6666",
        stateName: "未开票"
    },
    {
        stateId: "7777",
        stateName: "开票中"
    },
    {
        stateId: "9999",
        stateName: "开票失败"
    },
]